import { render, staticRenderFns } from "./billLadingEdit.vue?vue&type=template&id=74ece456&scoped=true&"
import script from "./billLadingEdit.vue?vue&type=script&lang=js&"
export * from "./billLadingEdit.vue?vue&type=script&lang=js&"
import style0 from "./billLadingEdit.vue?vue&type=style&index=0&id=74ece456&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ece456",
  null
  
)

export default component.exports